class ProductSlideTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.product-slide__tab-button');
    this.sectionId = this.closest('.product-slide').querySelector('[id^="productSlideSwiper-"]').id.split('-')[1];
    this.activeGroup = this.getGroupFromCookie();

    // Set initial state from cookie or default to group_1
    if (this.activeGroup == null) this.activeGroup = "group_1";
    this.applyActiveState(this.activeGroup);

    // Add click listeners to all tab buttons
    this.addEventListener('click', this.handleTabClick.bind(this));
  }

  handleTabClick(event) {
    let target = event.target;

    // Ensure we're clicking a button
    if (target.tagName.toLowerCase() !== 'button') {
      target = target.closest('button');
    }

    if (target && target.classList.contains('product-slide__tab-button')) {
      const selectedGroup = target.dataset.group;
      this.switchGroup(selectedGroup);
      this.setGroupCookie(selectedGroup);
    }
  }

  switchGroup(group) {
    // Update button states
    this.buttons.forEach(button => {
      if (button.dataset.group === group) {
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-pressed', 'false');
      }
    });

    // Show/hide swiper containers
    const containers = document.querySelectorAll(`[id^="productSlideSwiper-${this.sectionId}-"]`);
    containers.forEach(container => {
      if (container.dataset.group === group) {
        container.classList.remove('product-slide__group--hidden');
      } else {
        container.classList.add('product-slide__group--hidden');
      }
    });

    this.activeGroup = group;
  }

  applyActiveState(group) {
    this.switchGroup(group);
  }

  setGroupCookie(group) {
    document.cookie = `selectedProductSlideGroup=${group}; path=/; max-age=31536000`; // 1 year expiry
  }

  getGroupFromCookie() {
    const name = "selectedProductSlideGroup=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return null;
  }
}

customElements.define('product-slide-tabs', ProductSlideTabs);
